<template>
  <div class="login-container">
    <form @submit="login" class="login-form">
      <h1 class="logo"><em>Data</em>poort</h1>
      <input placeholder="Username" v-model="username" type="text" autocomplete="username" />
      <p v-if="usernameError">{{ usernameError }}</p>
      <input
        placeholder="Password"
        v-model="password"
        type="password"
        autocomplete="current-password"
      />
      <p v-if="passwordError">{{ passwordError }}</p>
      <input type="submit" value="Login" class="btn btn-primary" />
      <router-link class="btn btn-secondary" :to="{ name: 'forgot-password' }"
        >Wachtwoord vergeten</router-link
      >
    </form>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { userLoginRequestSchema } from '@/types/user.ts'
import z from 'zod'
import { useUserStore } from '@/stores/user.ts'
import { useRouter } from 'vue-router'

const username = ref<string>('')
const password = ref<string>('')

const usernameError = ref<string | null>(null)
const passwordError = ref<string | null>(null)

const router = useRouter()
const userStore = useUserStore()
const login = (event: Event) => {
  event.preventDefault()

  const result = userLoginRequestSchema.safeParse({
    username: username.value,
    password: password.value,
  })

  if (!result.success) {
    const errors = z.flattenError(result.error).fieldErrors

    usernameError.value = errors.username?.[0] ?? null
    passwordError.value = errors.password?.[0] ?? null

    return
  }

  userStore.login(result.data).then(() => router.push({ name: 'dashboard' }))

  return false
}
</script>
